import { render, staticRenderFns } from "./QuotaDefaultRatio.vue?vue&type=template&id=22160060&scoped=true&"
import script from "./QuotaDefaultRatio.vue?vue&type=script&lang=js&"
export * from "./QuotaDefaultRatio.vue?vue&type=script&lang=js&"
import style0 from "./QuotaDefaultRatio.vue?vue&type=style&index=0&id=22160060&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22160060",
  null
  
)

export default component.exports